"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NodeCache = require("node-cache");
const CACHE_TTL_IN_SEC = 30;
const cache = new NodeCache();
function cacheResourcePermissions(cacheKey, resourcePermissions) {
    cache.set(cacheKey, resourcePermissions, CACHE_TTL_IN_SEC);
}
exports.cacheResourcePermissions = cacheResourcePermissions;
function readResourcePermissions(cacheKey) {
    return cache.get(cacheKey);
}
exports.readResourcePermissions = readResourcePermissions;
function shouldRefreshCache(cacheKey) {
    return (Math.random() < Math.pow(getAgeInSeconds(cacheKey) / CACHE_TTL_IN_SEC, 4));
}
exports.shouldRefreshCache = shouldRefreshCache;
function getAgeInSeconds(cacheKey) {
    const ttl = cache.getTtl(cacheKey);
    if (!ttl) {
        return CACHE_TTL_IN_SEC;
    }
    const age = CACHE_TTL_IN_SEC - (ttl - Date.now()) / 1000;
    return age;
}
exports.getAgeInSeconds = getAgeInSeconds;
function setTTL(cacheKey, ttl) {
    cache.ttl(cacheKey, ttl);
}
exports.setTTL = setTTL;
//# sourceMappingURL=coam-cache.js.map